import './Footer';
import './Header';
import './Course';
import './Teacher';
import './Table';
import './Popup';
import './MapSelector';



/** WEBPACK FOOTER **
 ** ./components/index.js
 **/